import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
import React from 'react';
import Input from '../../../common/components/v2/form/Input';

const SearchInput = ({
  onChange,
  value,
}: {
  onChange: (value: string) => void;
  value: string;
}) => (
  <Input
    sx={{
      '& .MuiOutlinedInput-root': {
        padding: 0,
        display: 'flex',
        alignItems: 'center',
      },
    }}
    slotProps={{
      input: {
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ width: '20px', height: '20px', ml: '12px' }} />
          </InputAdornment>
        ),
      },
    }}
    placeholder="Search..."
    value={value}
    onChange={e => onChange(e.target.value)}
  />
);

export default SearchInput;
